module.exports = __webpack_public_path__ + "img/10.3ed0b6a7.png";